export default __webpack_public_path__ + "static/hosting-011dd1a59e974df89b8b1c251b3a09b9.jpg";